module.exports = __webpack_public_path__ + "img/breakfast_bistro_logo_small.7545cbcf.png";